var map = {
	"./affix/style/index.tsx": 1036,
	"./alert/style/index.tsx": 1038,
	"./anchor/style/index.tsx": 1040,
	"./auto-complete/style/index.tsx": 1042,
	"./avatar/style/index.tsx": 1047,
	"./back-top/style/index.tsx": 1049,
	"./badge/style/index.tsx": 1051,
	"./breadcrumb/style/index.tsx": 1053,
	"./button/style/index.tsx": 124,
	"./calendar/style/index.tsx": 1055,
	"./card/style/index.tsx": 1058,
	"./carousel/style/index.tsx": 1061,
	"./cascader/style/index.tsx": 1063,
	"./checkbox/style/index.tsx": 207,
	"./col/style/index.tsx": 1066,
	"./collapse/style/index.tsx": 1067,
	"./date-picker/style/index.tsx": 1069,
	"./divider/style/index.tsx": 1073,
	"./drawer/style/index.tsx": 1075,
	"./dropdown/style/index.tsx": 961,
	"./form/style/index.tsx": 1078,
	"./grid/style/index.tsx": 393,
	"./icon/style/index.tsx": 1080,
	"./input-number/style/index.tsx": 1081,
	"./input/style/index.tsx": 123,
	"./layout/style/index.tsx": 1083,
	"./list/style/index.tsx": 1085,
	"./locale-provider/style/index.tsx": 1089,
	"./mention/style/index.tsx": 1091,
	"./menu/style/index.tsx": 1093,
	"./message/style/index.tsx": 1096,
	"./modal/style/index.tsx": 1098,
	"./notification/style/index.tsx": 1100,
	"./pagination/style/index.tsx": 395,
	"./popconfirm/style/index.tsx": 1102,
	"./popover/style/index.tsx": 962,
	"./progress/style/index.tsx": 963,
	"./radio/style/index.tsx": 391,
	"./rate/style/index.tsx": 1105,
	"./row/style/index.tsx": 1107,
	"./select/style/index.tsx": 206,
	"./slider/style/index.tsx": 1108,
	"./spin/style/index.tsx": 394,
	"./steps/style/index.tsx": 1110,
	"./switch/style/index.tsx": 1112,
	"./table/style/index.tsx": 1114,
	"./tabs/style/index.tsx": 958,
	"./tag/style/index.tsx": 960,
	"./time-picker/style/index.tsx": 959,
	"./timeline/style/index.tsx": 1116,
	"./tooltip/style/index.tsx": 389,
	"./transfer/style/index.tsx": 1118,
	"./tree-select/style/index.tsx": 1120,
	"./tree/style/index.tsx": 1122,
	"./upload/style/index.tsx": 1124,
	"./version/style/index.tsx": 1126
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1035;


//////////////////
// WEBPACK FOOTER
// ./components ^\.\/[^_][\w-]+\/style\/index\.tsx?$
// module id = 1035
// module chunks = 1